@if (isSuperAdmin && userId) {
<div class="rounded-xl border border-neutral-200 overflow-hidden">
  <div class="flex items-center justify-between gap-3 px-4 py-3 bg-neutral-50">
    <div class="flex items-center gap-3 min-w-0">
      <span class="h-9 w-9 rounded-lg bg-amber-100 text-amber-700 flex items-center justify-center flex-shrink-0"><mat-icon class="!h-5 !w-5 !text-[20px]">lock_reset</mat-icon></span>
      <div class="min-w-0">
        <div class="text-sm font-semibold text-neutral-800">Password</div>
        <div class="text-xs text-neutral-500">Set a new password for {{ name }} if they're locked out or new.</div>
      </div>
    </div>
    @if (!open && !savedPassword) {
    <button type="button" class="text-xs font-semibold px-3.5 py-2 rounded-lg bg-white border border-neutral-300 text-neutral-700 hover:border-amber-400 hover:bg-amber-50 transition-colors flex-shrink-0" (click)="open = true">
      Set new password
    </button>
    }
  </div>

  @if (open) {
  <div class="px-4 py-4 border-t border-neutral-200 flex flex-col gap-3">
    <div class="flex items-stretch gap-2">
      <div class="relative flex-1">
        <input [type]="visible ? 'text' : 'password'" autocomplete="new-password" spellcheck="false"
          class="w-full pl-3 pr-10 py-2.5 rounded-lg border bg-neutral-50 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-amber-400"
          [class]="tooShort ? 'border-red-400' : 'border-neutral-300'"
          placeholder="At least 8 characters" [(ngModel)]="password" (keydown.enter)="save()" />
        <button type="button" class="absolute right-1.5 top-1/2 -translate-y-1/2 h-8 w-8 rounded-full text-neutral-400 hover:text-neutral-700 hover:bg-neutral-200 flex items-center justify-center" (click)="visible = !visible" [attr.aria-label]="visible ? 'Hide password' : 'Show password'">
          <mat-icon class="!h-5 !w-5 !text-[20px]">{{ visible ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </div>
      <button type="button" class="px-3.5 rounded-lg border border-neutral-300 bg-white text-xs font-semibold text-neutral-700 hover:border-amber-400 hover:bg-amber-50 transition-colors flex items-center gap-1.5" (click)="generate()" matTooltip="Make a strong password">
        <mat-icon class="!h-[18px] !w-[18px] !text-[18px]">auto_fix_high</mat-icon> Generate
      </button>
    </div>
    @if (tooShort) { <div class="text-xs text-red-600 -mt-1">At least 8 characters.</div> }
    <div class="flex items-center justify-end gap-2">
      <button type="button" class="text-xs font-semibold px-3.5 py-2 rounded-lg text-neutral-600 hover:bg-neutral-100 transition-colors" (click)="close()">Cancel</button>
      <button type="button" class="text-xs font-bold px-4 py-2 rounded-lg bg-amber-400 text-neutral-900 hover:bg-amber-300 transition-colors disabled:opacity-50" [disabled]="saving || password.length < 8" (click)="save()">
        {{ saving ? 'Saving...' : 'Set password' }}
      </button>
    </div>
    <p class="text-[11px] text-neutral-400">Tell them the new password securely. Anyone already signed in stays signed in until their session expires.</p>
  </div>
  }

  @if (savedPassword) {
  <div class="px-4 py-4 border-t border-emerald-200 bg-emerald-50/60 flex flex-col gap-2">
    <div class="flex items-center gap-2 text-sm font-semibold text-emerald-800"><mat-icon class="!h-5 !w-5 !text-[20px]">check_circle</mat-icon> Password updated</div>
    <div class="flex items-center gap-2">
      <code class="flex-1 px-3 py-2 rounded-lg bg-white border border-emerald-200 text-sm font-mono select-all break-all">{{ savedPassword }}</code>
      <button type="button" class="px-3 py-2 rounded-lg bg-white border border-emerald-200 text-xs font-semibold text-emerald-800 hover:bg-emerald-100 transition-colors flex items-center gap-1" (click)="copy(savedPassword)"><mat-icon class="!h-4 !w-4 !text-[16px]">content_copy</mat-icon> Copy</button>
    </div>
    <div class="flex justify-end"><button type="button" class="text-xs font-semibold text-neutral-500 hover:text-neutral-800" (click)="close()">Done</button></div>
  </div>
  }
</div>
}
